<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update SD Status</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />



        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="sd_statusDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="description"
                class="w-full"
                v-model="sd_statusDescription.description"
                v-validate="'required'"
                data-vv-as="SDStatus"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
   

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <!-- <DataGrid :context="'SDStatus'" 
            ref="sd_status"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid> -->
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleSDStatusManagement from "@/store/sd-status-management/moduleSDStatusManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
       please_choose_type: null,
      selected_sales_developer: [],
      user_role: null,
      sd_statusDescription: [],
      sd_status_id: null,
      columnDefs: [
        {
          headerName: "SDStatus",
          flex: 1,
          field: "status",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
 
      ],
      dataSource: {},
      records: [],
      selected: [],
      allSDStatus: [],
      abilities: null,
      sd_statusDescription: {
          sd_status: null,
        description: null,
        type: null,
        sales_developer_id:null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleSDStatusManagement,
    DataGrid
      },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });


    if (!moduleSDStatusManagement.isRegistered) {
      this.$store.registerModule("SDStatusManagement", moduleSDStatusManagement);
      moduleSDStatusManagement.isRegistered = true;
    }
  },
  mounted() {
    this.sd_status_id = this.$route.params.statusId;
    this.fetchSDStatus();
  },
  watch: {},
  methods: {
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {

          self.$store
            .dispatch("SDStatusManagement/getAllSDStatus", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.sd_status.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.sd_status.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.push({ path: "/sd_statuses" });
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateSDStatus();
        }
      });
    },
    updateSDStatus() {
      this.$store
        .dispatch("SDStatusManagement/updateSDStatus", this.sd_statusDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "SDStatus Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "SDStatus Updated",
              text: "The sd_status was updated successfully"
            });
            this.$router.push({ path: "/sd_statuses" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchSDStatus() {
      let self = this;
      this.$store
        .dispatch("SDStatusManagement/fetchSDStatus", self.sd_status_id)
        .then(res => {
          let result = JSON.parse(res.data);

          self.sd_statusDescription = result[0];
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
